import { EmploymentStatDTO } from "./employment-status.dto";
import { EmploymentStatus } from "../employment-status.entity";
import { Injectable } from "@nestjs/common";

@Injectable()
export class EmployStatAdapter{

    public convertDtoToEntity(employStatDTO: EmploymentStatDTO, isUpdate: boolean = false): EmploymentStatus{
        const employStatEntity = new EmploymentStatus();
        employStatEntity.employmentStatusId = employStatDTO.employmentStatusId;
        employStatEntity.employmentStatus = employStatDTO.employmentStatus;
        employStatEntity.isActive = employStatDTO.isActive == undefined ? true : employStatDTO.isActive;
        if(isUpdate){
            employStatEntity.updatedUser = employStatDTO.updatedUser;
        } else {
            employStatEntity.isActive = true;
            employStatEntity.createdUser = employStatDTO.createdUser;
        }
        return employStatEntity;
    }

    public convertEntityToDto(employStatEntity: EmploymentStatus): EmploymentStatDTO{
        const employStatDTO = new EmploymentStatDTO;
        employStatDTO.employmentStatusId = employStatEntity.employmentStatusId;
        employStatDTO.employmentStatus = employStatEntity.employmentStatus;
        employStatDTO.isActive = employStatEntity.isActive;
        employStatDTO.createdAt = employStatEntity.createdAt;
        employStatDTO.updatedAt = employStatEntity.updatedAt;
        employStatDTO.createdUser = employStatEntity.createdUser;
        employStatDTO.updatedUser = employStatEntity.updatedUser;
        employStatDTO.versionFlag = employStatEntity.versionFlag;
        return employStatDTO;
    }
}

